import React, { useState } from "react";
import { registerUser } from "../Login/Apis/api";
import { useNavigate, Link } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export const Signup = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const history = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await registerUser(name, phone, email, password);
      // Assuming successful registration directly allows login or redirect to login
      history("/login");
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setError(error.response.data.message);
      } else {
        setError("An error occurred during registration.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="d-flex align-items-center justify-content-center" 
      style={{ minHeight: "100vh", padding: "20px", marginTop: "-55px" }}
    >
      <div 
        className="glass-card" 
        style={{ width: "100%", maxWidth: "420px", padding: "40px 30px" }}
      >
        <div className="text-center mb-4">
          <div 
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              background: "linear-gradient(135deg, var(--primary) 0%, var(--success) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              marginBottom: "8px"
            }}
          >
            My Money
          </div>
          <p style={{ color: "var(--text-secondary)", fontSize: "0.95rem" }}>
            Create an account to track your wealth
          </p>
        </div>

        {error && (
          <div 
            className="alert alert-danger" 
            style={{ 
              borderRadius: "12px", 
              backgroundColor: "rgba(239, 68, 68, 0.1)", 
              border: "1px solid rgba(239, 68, 68, 0.2)", 
              color: "var(--danger)",
              fontSize: "0.9rem" 
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSignUp}>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder=" "
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <label htmlFor="name">Full Name</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="number"
              className="form-control"
              id="phone"
              placeholder=" "
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
            <label htmlFor="phone">Phone Number</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder=" "
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label htmlFor="email">Email</label>
          </div>
          <div className="form-floating mb-3 position-relative">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              id="password"
              placeholder=" "
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label htmlFor="password">Password</label>
            <div 
              className="position-absolute" 
              style={{ top: "50%", right: "15px", transform: "translateY(-50%)", cursor: "pointer", zIndex: 10, color: "var(--text-secondary)" }}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </div>
          </div>
          <div className="form-floating mb-4 position-relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              className="form-control"
              id="confirmPassword"
              placeholder=" "
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <label htmlFor="confirmPassword">Confirm Password</label>
            <div 
              className="position-absolute" 
              style={{ top: "50%", right: "15px", transform: "translateY(-50%)", cursor: "pointer", zIndex: 10, color: "var(--text-secondary)" }}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
            </div>
          </div>
          <button 
            type="submit" 
            className="btn btn-primary w-100 mb-3" 
            style={{ padding: "12px", fontSize: "1rem", fontWeight: "600" }}
            disabled={loading}
          >
            {loading ? "Signing up..." : "Sign Up"}
          </button>
          
          <div className="text-center">
            <span style={{ color: "var(--text-secondary)", fontSize: "0.9rem" }}>
              Already have an account?{" "}
            </span>
            <Link 
              to="/login" 
              style={{ 
                color: "var(--primary)", 
                textDecoration: "none", 
                fontWeight: "600",
                fontSize: "0.9rem" 
              }}
            >
              Sign In
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};
